export class AreaContactDto {
  areaId: string;
  areaName: string;
  fiberHood: string;
  city: string;
  block: number;
  contactId: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  ownerId: string;
  ownerName: string;
  state?: AreaContactSaveState;
}

export enum AreaContactSaveState {
  unknown,
  ongoing,
  done,
  failed,
}
